import { c as _c } from "react/compiler-runtime";
import { Tabbar } from '@systemeio/components';
import { useState, type ReactNode } from 'react';
import { CARD_FRAME_CLASSNAME } from 'shared/constants/card-class-names';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { twJoin } from 'tailwind-merge';
import { SmsSubstitutesBlock } from './sms-substitutes-block';
type SmsTemplateSettingsTab = 'sender' | 'personalization';
const PANEL_CONTENT_CLASSNAME = 'pt-9 pb-4';
interface SmsTemplateSettingsPanelProps {
  sender: ReactNode;
  hasSenderError: boolean;
}
export const SmsTemplateSettingsPanel = t0 => {
  const $ = _c(27);
  const {
    sender,
    hasSenderError
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const [activeTab, setActiveTab] = useState("sender");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = twJoin(CARD_FRAME_CLASSNAME, "min-w-0 px-5 py-4");
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = value => setActiveTab(value as SmsTemplateSettingsTab);
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = t("dashboard.sms.sender");
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t) {
    t4 = t("dashboard.sms.sender");
    $[4] = t;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== hasSenderError || $[7] !== t3 || $[8] !== t4) {
    t5 = {
      children: t3,
      overflowLabel: t4,
      value: "sender",
      hasError: hasSenderError
    };
    $[6] = hasSenderError;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t("dashboard.sms.personalization");
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t) {
    t7 = t("dashboard.sms.personalization");
    $[12] = t;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = {
      children: t6,
      overflowLabel: t7,
      value: "personalization"
    };
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t5 || $[18] !== t8) {
    t9 = [t5, t8];
    $[17] = t5;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== sender) {
    t10 = <Tabbar.Panel value="sender" keepMounted={true} data-test="sms-template-sender"><div className={PANEL_CONTENT_CLASSNAME}>{sender}</div></Tabbar.Panel>;
    $[20] = sender;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Tabbar.Panel value="personalization" keepMounted={true} data-test="sms-template-personalization"><div className={PANEL_CONTENT_CLASSNAME}><SmsSubstitutesBlock /></div></Tabbar.Panel>;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== activeTab || $[24] !== t10 || $[25] !== t9) {
    t12 = <div className={t1}><Tabbar value={activeTab} onValueChange={t2} tabs={t9}>{t10}{t11}</Tabbar></div>;
    $[23] = activeTab;
    $[24] = t10;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  return t12;
};